// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--cA3NU","stars":"_02712f2b3b--stars--HqPhw","list":"_02712f2b3b--list--YKlpb","item":"_02712f2b3b--item--p588o"};